import Backend from 'i18next-locize-backend'
import {initReactI18next} from 'react-i18next'
import i18next from 'i18next'

const apiKey = process.env.REACT_APP_LOCIZE

const locizeEnv = process.env.REACT_APP_LOCIZE_ENV.toLowerCase()
console.log('locize env:', locizeEnv)

const locizeOptions = {
  projectId: '86390ca7-f7f2-4f80-947d-56ad36a89671',
  referenceLng: 'en',
  version: locizeEnv,
  apiKey,
  onSaved: (lng, ns) => {
    console.log('sent translations to locize', {lng, ns})
  }
}

const getNamespacesToPreload = () => {
  const usedNamespaces =
    i18next.reportNamespaces && typeof i18next.reportNamespaces.getUsedNamespaces === 'function'
      ? i18next.reportNamespaces.getUsedNamespaces()
      : []
  const configuredNamespaces = Array.isArray(i18next.options.ns)
    ? i18next.options.ns
    : [i18next.options.defaultNS || 'common']

  return Array.from(new Set([...configuredNamespaces, ...usedNamespaces].filter(Boolean)))
}

export const preloadLanguageResources = language => {
  return new Promise((resolve, reject) => {
    i18next.reloadResources([language], getNamespacesToPreload(), err => {
      if (err) {
        reject(err)
        return
      }
      resolve()
    })
  })
}

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    ns: ['common'],
    defaultNS: 'common',
    lng: 'en',
    fallbackLng: 'en',
    debug: apiKey !== undefined,
    // debug: true,
    saveMissing: apiKey !== undefined,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: locizeOptions,
    locizeLastUsed: locizeOptions,
    react: {
      bindI18n: 'languageChanged editorSaved',
      wait: true
    }
  })

export default i18next
